import React from 'react';

/**
 * Modal confirmation dialog. Replaces window.confirm() across the app.
 * Usage: control via `confirm` state shape { message, onConfirm, confirmLabel?, destructive? }
 */
export default function ConfirmDialog({ confirm, onCancel }) {
  if (!confirm) return null;

  const { message, onConfirm, confirmLabel = 'Confirm', destructive = false } = confirm;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 10,
          padding: '28px 32px',
          maxWidth: 420,
          width: '90%',
          boxShadow: '0 4px 24px rgba(0,0,0,0.2)'
        }}
      >
        <p style={{ marginBottom: 24, fontSize: '1em', lineHeight: 1.5 }}>{message}</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button
            className="btn"
            onClick={onCancel}
            style={{ background: '#e9ecef' }}
          >
            Cancel
          </button>
          <button
            className="btn"
            onClick={() => { onConfirm(); onCancel(); }}
            style={{ background: destructive ? '#dc3545' : '#007bff', color: '#fff' }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
